import { useState } from 'react';

/** A scrollable code block with a copy button and optional line numbers. */
export function CodeBlock({
  code,
  numbered = false,
  maxHeight,
}: {
  code: string;
  numbered?: boolean;
  maxHeight?: number;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // Clipboard is unavailable over plain http and in some embedded views.
      // The text is selectable either way, so this is not worth an error.
    }
  };

  const lines = code.replace(/\n$/, '').split('\n');

  return (
    <div className="code">
      <button type="button" className="copy" onClick={copy}>
        {copied ? 'Copied' : 'Copy'}
      </button>
      <pre style={maxHeight ? { maxHeight, overflowY: 'auto' } : undefined}>
        <code>
          {numbered
            ? lines.map((line, i) => (
                <span className="line" key={i}>
                  <span className="ln">{i + 1}</span>
                  {line || ' '}
                </span>
              ))
            : code}
        </code>
      </pre>
    </div>
  );
}
